/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useObservable } from '@squiz/dxp-console-support';
import { useMemo } from 'react';
import { Observable } from 'rxjs';
import { EntityScvSchema } from '../../Entities/ScvSchema/ScvSchema.entity';
import { getScvService } from '../../Utilities/GetScvService/GetScvService';

/**
 * React hook to get the schema for the current organization.
 * @export
 * @returns {EntityScvSchema | null} The schema object, or null if no value is available.
 */
export function useScvSchema(): EntityScvSchema | null {
  const singleCustomerViewService = getScvService();

  const schema$ = useMemo((): Observable<EntityScvSchema | null> => {
    return singleCustomerViewService.getSchema();
  }, [singleCustomerViewService]);

  const [schema] = useObservable(schema$, [singleCustomerViewService]);
  return schema;
}
